import { useState } from 'react';

import { useRequestNewInsured } from './useMyTeam5';
import { useTeamStore } from './useTeamStore';

import useToast from '@/hooks/useToast';
import { TeamActionTypes } from '@/store';
import { TemplatePlayer } from '@/types/team';

export const useHandleChangeInsured = () => {
  const { dispatch } = useTeamStore();
  const [updateInsured, setIsUpdateInsured] = useState({
    id: 0,
    isUpdateInsured: false,
  });
  const toast = useToast();
  const {
    data: responseNewInsured,
    isLoading: isLoadingNewInsured,
    mutateAsync: requestNewInsuredF5,
  } = useRequestNewInsured();

  const resetState = () => {
    dispatch({
      type: TeamActionTypes.SET_STATE,
      payload: {
        playerDetailsModalOpen: false,
        showPlayersListTransfer: false,
      },
    });
  };

  const handleNewInsured = async (player: TemplatePlayer) => {
    // no se pueden realizar cambios por la veda
    // se deja pasar al servicio de backend
    // if (userInitialData?.veda) {
    //   toast.show(TEXTS.veda);
    //   resetState();
    //   return;
    // } else
    // if (userInitialData?.todoPublicado) {
    //   // no se pueden realizar cambios porque termino GDT
    //   toast.show(TEXTS.gdtHasEnded);
    //   resetState();
    //   return;
    // }
    // https://agea.atlassian.net/browse/DTA-7944
    if (player) {
      // se realiza posteo de nuevo capitan
      const response = await requestNewInsuredF5({
        aseguradoNuevo: player.id,
      });
      if (response.estado) {
        resetState();
        setIsUpdateInsured({ id: player.id, isUpdateInsured: true });
      } else {
        toast.show(response.mensaje);
      }
    }
  };
  return {
    handleNewInsured,
    responseNewInsured,
    isLoadingNewInsured,
    updateInsured,
  };
};
